import React from 'react'

const Feedback = () => {
  return (
    <div>
   <div className="feedback container my-5">
    <h2 className='text-center'>Praise for <span className='bold'>Precision</span>  and <span className='bold'> Performance</span></h2>
    <p className="text-center">
    Here are some noteworthy recognitions and testimonials
that underscore our commitment to excellence</p>
<div className="col-md-8 col-md-4-offset m-auto">
<div className="text-center my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/1.JPG" alt="" className='img-fluid' />
</div>
<div className=" my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/2.JPG" alt="" className='img-fluid' />
</div>
<div className="text-center my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/3.JPG" alt="" className='img-fluid' />
</div>
<div className=" my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/4.JPG" alt="" className='img-fluid' />
</div>
<div className="text-center my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/5.JPG" alt="" className='img-fluid' />
</div>

<div className=" my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/6.JPG" alt="" className='img-fluid' />
</div>

<div className="text-center my-2">
    <img src="https://rabsnetsolutions.com/experience-center/assets/img/RABS_Landing_Page/review/8.JPG" alt="" className='img-fluid' />
</div>
</div>

    
   </div>
   <div className="text-center my-2">
  <img className="shake" src="https://rabsnetsolutions.com/experience-center/assets/img/membership/slider/arrow.png" alt="Shaking Image" />
</div>
    </div>
  )
}

export default Feedback
